
// require('normalize.css/normalize.css');
// require('./styles/index.scss');
//

import 'jquery';
import 'bootstrap';

import './styles/index.scss'

import './js/web.js';
